import { createI18n } from 'vue-i18n';
import en from './locales/generated-en.json';
import hu from './locales/generated-hu.json';

export const i18n = createI18n({
  locale: localStorage.getItem('locale') ?? 'en',
  messages: { en, hu },
  fallbackLocale: 'en',
  legacy: false,
});
